import React, { useRef } from 'react';
import { usePlayerContext } from '../../context/player-context';
import { formatTime } from '../../utils/time-utils';

export const StoryboardPreview: React.FC = () => {
  const { hoverPreview, storyboard } = usePlayerContext();
  const previewContainerRef = useRef<HTMLDivElement>(null);

  if (!hoverPreview.visible || !storyboard || !storyboard.url) {
    return null;
  }

  return (
    <div
      ref={previewContainerRef}
      className="flex flex-col items-center"
      style={{
        position: 'absolute',
        bottom: '80px',
        left: hoverPreview.x,
        transform: hoverPreview.isAtLeftEdge
          ? 'translateX(-40%)'
          : hoverPreview.isAtRightEdge
            ? 'translateX(-60%)'
            : 'translateX(-50%)',
        pointerEvents: 'none',
        zIndex: 40,
      }}
    >
      <div
        style={{
          width: hoverPreview.width,
          height: hoverPreview.height,
          backgroundImage: storyboard ? `url(${storyboard.url})` : 'none',
          backgroundPosition: hoverPreview.backgroundPosition,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'auto',
          borderRadius: '8px',
          border: '1px solid #fff',
        }}
      />

      {hoverPreview.hoverTime !== undefined && (
        <div
          className="px-2 py-1 mt-1 text-xs font-medium text-white bg-black rounded-sm bg-opacity-70"
          style={{
            textAlign: 'center',
            minWidth: '60px',
            alignSelf: 'center',
          }}
        >
          {formatTime(hoverPreview.hoverTime)}
        </div>
      )}
    </div>
  );
};
